module.exports = __webpack_public_path__ + "img/webinars-3.f29cc940.png";